import {StyleSheet} from 'aphrodite';

import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {ProcessTaskForPopoverGql} from './graphql';

export interface GetChipPopoverContentsArgs {
  processTask: ProcessTaskForPopoverGql;
  icon: BenchlingIconName | null;
}

export const CHIP_POPOVER_STYLES = StyleSheet.create({
  statusWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
